import { getApiCall } from './httpCall';
import { getUserAccessToken } from '@/utilities/setting';

const SHARE_MS = 10000;
const recent = new Map<string, { at: number; p: Promise<any> }>();

export function getApiCallShared(url: string): Promise<any> {
  const key = `${getUserAccessToken() || ''}|${url}`;
  const hit = recent.get(key);
  if (hit && Date.now() - hit.at < SHARE_MS) return hit.p;
  const p = getApiCall(url, undefined);
  recent.set(key, { at: Date.now(), p });
  p.catch(() => {
    if (recent.get(key)?.p === p) recent.delete(key);
  });
  return p;
}

export function clearApiCallShared() {
  recent.clear();
}
